import { CommonDialogs } from "@mcleod/common";
import { LogManager, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutWireFundsProcessingToolPanel } from "./autogen/AutogenLayoutWireFundsProcessingToolPanel";
import { Button, ClickEvent, DropdownItem, Snackbar, TextboxProps } from "@mcleod/components";
const log = LogManager.getLogger("WireFundsProcessingToolPanel");

export class WireFundsProcessingToolPanel extends AutogenLayoutWireFundsProcessingToolPanel {
    private _searchCallback: (updatedRows?: ModelRow<any>) => void;
    /** This is an event handler for the onClick event of buttonUpdateStatuses. */
    buttonUpdateStatusesOnClick(event: ClickEvent) {
        const table = this.owner.tableWireFundsProcessing;
        if (!table) {
            log.error("Table not found in parent layout");
            return;
        }
        const selectedRows = table.selectedRows;
        if (selectedRows.length === 0) {
            Snackbar.showSnackbar("Please select at least one row to update.");
            return;
        }
        const textboxProps: Partial<TextboxProps> = {
            items: [
                new DropdownItem("P", "Ready to Process"),
                new DropdownItem("H", "Hold"),
                new DropdownItem("V", "Void"),
                new DropdownItem("U", "Unverified")
            ]
        };
        CommonDialogs.showInputDialog("Enter a New Status", "Update Status", textboxProps).then(async response => {
            const updateRows: ModelRow[] = [];
            let successCount = 0;

            if (!response) {
                Snackbar.showSnackbar("No status selected.");
                return;
            }
            // Get all selected rows
            selectedRows.forEach(row => {
                const wireRow: ModelRow = row?.data;
                wireRow.set("status", response);
                updateRows.push(wireRow);
            });
            if (updateRows.length > 0) {
                const button = event.target as Button;
                button.busy = true;
                try {
                    await Promise.all(updateRows.map(async row => {
                        try {
                            await row.post();
                            if (this.searchCallback) {
                                this.searchCallback(row);
                            }
                            successCount++;
                        } catch (error) {
                            row.set("status", row.originalData["status"]); // Reset the status to the original value
                            throw error;
                        }
                        log.debug("Rows posted successfully: ", row);
                    }));
                    Snackbar.showSnackbar(StringUtil.pluralString(successCount, "Wire status", "Wire statuses") + " updated successfully.");
                } finally {
                    button.busy = false;
                    log.debug("Row: ", updateRows);
                }
            }

        });

    }

    get searchCallback(): (updatedRow?: ModelRow<any>) => void {
        return this._searchCallback;
    }

    set searchCallback(searchCallback: (updatedRow?: ModelRow<any>) => void) {
        this._searchCallback = searchCallback;
    }
}
